import React from 'react';
import EnergyLoader from '../../../Components/EnergyLoader';

const LoadingScreen = ({ message }) => <EnergyLoader message={message || 'Carregando...'} />;

export default LoadingScreen;
